import Footer from './Footer.vue'
export {Footer}
export default Footer

